import * as React from 'react';
import { COLLAPSED_ROW_HEIGHT, COLUMNS_START_PADDING } from '../../layout';
import { useExpandedColumns, useOrganizations, useReleases, useRowHeights, useTasksByOrganizationAndRelease } from '../../state/context';
import ColumnGrid from '../ColumnGrid';
import OrganizationRowCell from './OrganizationRowCell';

const OrganizationRows = () => {
  const organizations = useOrganizations();
  const rowHeights = useRowHeights();
  const tasks = useTasksByOrganizationAndRelease();
  const releases = useReleases();
  const [expandedColumns] = useExpandedColumns();

  return (
    <div>
      <ColumnGrid />
      {organizations.map((organization) => (
        <div
          key={organization.id}
          className="flex items-center transition-height"
          style={{
            height: rowHeights[organization.id] || COLLAPSED_ROW_HEIGHT,
            paddingLeft: COLUMNS_START_PADDING,
          }}
        >
          {releases.map((release) => (
            <OrganizationRowCell
              key={release.id}
              tasks={tasks[`${organization.id}-${release.id}`] || []}
              isColumnExpanded={expandedColumns.includes(release.id)}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default OrganizationRows;
